import { createStyles } from "@mantine/emotion";

export default createStyles ( () => {
	return {
		containerClass: {
			width: "100%"
		}
	};
} );